<template>
  <a-modal
    :title="title"
    :visible="visible"
    :closable="false"
  >
    <a-progress :percent="progressPercent" status="active" />
    <span v-if="content">{{ content }}...</span>
    <template slot="footer">
      <a-button :loading="btnLoading" @click="cancel">{{ btnText }}</a-button>
    </template>
  </a-modal>
  
</template>

<script>
import { formulaMixins } from '../unitls'
export default {
  props: ['t'],
  data(){
    return {
      btnLoading: false
    }
  },
  mixins:[formulaMixins],
  computed: {
    visible:{
      get(){ return this.progressVisible },
      set(){},
    },
    title(){
      return this.progressModalTitle || '正在同步最新配方'
    },
    btnText(){
      return this.progressModalBtnText || '取消同步'
    },
    content(){
      return this.progressModalContent || ''
    },
  },
  methods: {
    cancel(){
      this.btnLoading = true
      setTimeout(() => {
        this.setState({
          progressVisible: false,
          progressType: false,
          progressModalTitle: '',
          progressModalBtnText: '',
          progressModalContent: '',
          progressPercent: 0,
        })
        if(this.progressModalUrl) this.$router.push(this.progressModalUrl)
        this.btnLoading = false
        this.$emit('ok')
      }, this.t || 0);
    }
  },
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>